import React, { useState } from "react";
import { Col, Form, Row, Button } from "react-bootstrap";
import Select from "react-select";
import PhoneInput from "react-phone-input-2";
import { useForm } from "react-hook-form";
import { zodResolver } from "@hookform/resolvers/zod";
import { z } from "zod";
import AddressInput from "../../../components/Common/address";
import CommonInput from "./CommonInput";
import { catchAsync } from "../../../utilities/utilies";
import fileUploader from "../../../utilities/fileUploader";
import {
  GET_ESTIMATED_PRICE,
  PICKUP_DROP_SAVE,
} from "../../../services/ApiCalls";
import { toast } from "react-toastify";
import { GoogleApiWrapper, Map, Marker } from "google-maps-react";
import GoogleMapConfig from '../../../config'



const requiredString = (name) =>
  z
    .string({})
    .trim()
    .min(1, { message: name + " is required" });

const optionalString = () => z.string().optional();

const requiredNumber = (name) =>
  z.number({ required_error: name + " is required" });

const Step2 = ({
  step,
  setStep,
  selectedService,
  step1FormData,
  formData,
  step2FormData,
  setStep2FormData,
}) => {
  console.log(step2FormData, "step2FormData");
  const [estimatedAmount, setEstimatedAmount] = useState(0);
  const getSchema = () => {
    return z.object({
      dropOffAddress: requiredString("Drop off Address"),
      dropOffCoordinates: z.object(
        {
          lng: requiredNumber("Drop off Address"),
          lat: requiredNumber("Drop off Address"),
        },
        { required_error: "Drop off address is required" }
      ),
      dropOffContactName: requiredString("Drop off contact Name"),
      dropOffContactNumber: requiredString("Drop off contact Number"),
      dropOffCountryCode: requiredString("Drop off contact Number"),

      dropOffDate: optionalString("Drop off Date"),
      dropOffTime: optionalString("Drop off Time"),
      estimatedAmount: z
        .string()

        .refine((val) => val >= estimatedAmount, {
          message: `Amount must be at least ${estimatedAmount}`,
        }),
      dropOffLandmark: optionalString("Drop Off Landmark"),
    });
  };
  const schema = getSchema();
  const {
    register,
    handleSubmit,
    formState: { errors },
    setValue,
    watch,
    getValues,
    trigger,
    setError: setFormError,
  } = useForm({
    resolver: zodResolver(schema),
    defaultValues: step2FormData,
  });

  const [images, setImages] = useState([]);
  const [imageUploadLoader, setImageUploadLoader] = useState(false);
  const [loader, setLoader] = useState(false);
  const [coordinates, setCoordinates] = useState(null);

  const onLatLongGet = (latLong) => {
    setCoordinates(latLong)
    setValue("dropOffCoordinates", latLong, { shouldValidate: true });
  };

  const submitHandler = async (values) => {
    setStep2FormData(values);
    // if (images?.length != 0) {
    try {
      let body = {
        price: step1FormData?.price,
        vendorDetails: step1FormData?.vendorId,
        serviceType: selectedService?.value,
        services: step1FormData?.services?.value,
        customerName: formData?.customerName,
        customerEmail: formData?.customerEmail,
        customerCountryCode: formData?.customerCountryCode,
        customerMobileNumber: formData?.customerMobileNumber,

        pickUp: {
          // pickUpType: {
          //   size: step1FormData?.pickUpTypeSize?.value,
          // },
          address: step1FormData?.pickUpAddress,
          coordinates: {
            lng: step1FormData?.pickUpCoordinates?.lng,
            lat: step1FormData?.pickUpCoordinates?.lat,
          },
          pickUpDate: step1FormData?.pickUpDate,
          pickUpTime: step1FormData?.pickUpTime,
          availability: step1FormData?.availability,
          pickUpContactName: step1FormData?.pickUpContactName,
          pickUpContactNumber: step1FormData?.pickUpContactNumber,
          pickUpCountryCode: step1FormData?.pickUpCountryCode,
          additionalNotes: step1FormData?.additionalNotes,
          weightCapacity: step1FormData?.weightCapacity,
        },

        dropOff: {
          address: values?.dropOffAddress,
          coordinates: {
            lng: values?.dropOffCoordinates?.lng,
            lat: values?.dropOffCoordinates?.lat,
          },
          dropOffContactName: values?.dropOffContactName,
          dropOffContactNumber: values?.dropOffContactNumber,
          dropOffDate: values?.dropOffDate,
          dropOffTime: values?.dropOffTime,
          estimatedAmount: values?.estimatedAmount,
          dropOffLandmark: values?.dropOffLandmark,
          dropOffCountryCode: values?.dropOffCountryCode,
        },
      };
      let newBody;
      if (selectedService?.value == "PickupDrop") {
        newBody = { ...body, image: images };
      } else {
        newBody = {
          ...body,
          towingVehicleDetails: {
            licensePlateNumber: step1FormData?.licensePlateNumber,
            make: step1FormData?.make,
            model: step1FormData?.model,
            color: step1FormData?.color,
            image: images,
          },
        };
      }
      // const res = await PICKUP_DROP_SAVE(newBody);
      // if (res?.data?.status == "success") {
      //   // setStep(0);
      //   setStep(3);
      //   toast.success(res?.data?.message);
      // } else {
      //   toast.error(res?.data?.message);
      // }
      // const amount = res?.data?.data || 0;
      // setEstimatedAmount(+amount);
      // setValue("estimatedAmount", +amount);

      localStorage.setItem("body", JSON.stringify(body));
      localStorage.setItem("newBody", JSON.stringify(newBody));
      setStep(3);
    } catch (error) { }
    // } else {
    //   toast.error("Please upload images");
    // }
  };

  console.log(errors, "errors");

  const imageUploadHandler = catchAsync(async (e) => {
    setImageUploadLoader(true);
    const url = await fileUploader(e?.target?.files[0]);

    if (!url) {
      setImageUploadLoader(false);
      return;
    }

    setImages((p) => [...p, url]);
    setImageUploadLoader(false);
  });

  const removeImageHandler = (value) => {
    setImages((p) => {
      const arr = [...p];
      const index = arr.findIndex((item) => item === value);

      if (index !== -1) {
        arr.splice(index, 1);
      }

      return arr;
    });
  };

  const handleGetCharges = async (val) => {
    console.log("drop add", val);

    try {
      let body = {
        price: step1FormData?.price,
        services:
          selectedService?.value == "PickupDrop"
            ? step1FormData?.services?.value
            : "Towing",

        pickUp: {
          address: step1FormData?.pickUpAddress,
          coordinates: {
            lng: step1FormData?.pickUpCoordinates?.lng,
            lat: step1FormData?.pickUpCoordinates?.lat,
          },
        },
        dropOff: {
          address: watch("dropOffAddress"),
          coordinates: {
            lng: val?.lng,
            lat: val?.lat,
          },
        },
      };
      const res = await GET_ESTIMATED_PRICE(body);
      const amount = res?.data?.data || 0;
      setEstimatedAmount(amount?.toString());
      setValue("estimatedAmount", amount?.toString());
    } catch (error) { }
  };

  // console.log(selectedService, step1FormData);

  return (
    <>
      <div className="top py-2 d-flex align-items-center gap-10">
        <Button
          onClick={() => setStep(1)}
          className="border-0 p-0"
          variant="transparent"
        >
          <svg
            width="20"
            height="20"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M22 20.418C19.5533 17.4313 17.3807 15.7367 15.482 15.334C13.5833 14.9313 11.7757 14.8705 10.059 15.1515V20.5L2 11.7725L10.059 3.5V8.5835C13.2333 8.6085 15.932 9.74733 18.155 12C20.3777 14.2527 21.6593 17.0587 22 20.418Z"
              fill="black"
              stroke="black"
              stroke-width="2"
              stroke-linejoin="round"
            />
          </svg>
        </Button>
        <h4 className="m-0 fw-sbold">Dropoff Location</h4>
      </div>
      <Form onSubmit={handleSubmit(submitHandler)}>
        <Row>
          {/* <Col lg="12" className="my-2">
            <iframe
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3430.6565013517534!2d76.68995827487977!3d30.6999393746002!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x390fef919b7bbba9%3A0xedc14bb423e0f91a!2sSuffescom%20Solutions!5e0!3m2!1sen!2sin!4v1731066681700!5m2!1sen!2sin"
              // width="600"
              height="450"
              className="h-100 w-100 rounded"
              allowfullscreen=""
              loading="lazy"
              referrerpolicy="no-referrer-when-downgrade"
            ></iframe>
          </Col> */}
          <Col md="12" className="my-2">
            <label htmlFor="" className="form-label m-0">
              Address
            </label>
            <AddressInput
              name="dropOffAddress"
              placeholder="Address"
              errorLabel="Address"
              required
              defaultValue=""
              onLatLongGet={onLatLongGet}
              setValue={(val) => {
                setValue("dropOffAddress", val, { shouldValidate: true });
              }}
              trigger={() => trigger("dropOffAddress")}
              value={watch("dropOffAddress")}
              handleGetCharges={handleGetCharges} // Trigger only on selection
            />
            {
              <p className="errorColor">
                {(errors?.dropOffAddress && errors?.dropOffAddress?.message) ||
                  (errors?.dropOffCoordinates &&
                    errors?.dropOffCoordinates?.message)}
              </p>
            }
          </Col>

          {/* {coordinates && (
            <Col md="12" className="my-2">
              <div style={{ height: "12rem" }}>
                <Map
                  google={google}
                  zoom={15}
                  center={coordinates}
                  style={{ height: "12rem" }}
                >
                  <Marker position={coordinates} />
                </Map>
              </div>
            </Col>
          )} */}

          {step1FormData?.availability === 'Schedule' && <>
            <Col md="6" className="my-2">
              <label htmlFor="" className="form-label m-0">
                Drop Off Date Date
              </label>
              <CommonInput
                register={register}
                errors={errors}
                name={"dropOffDate"}
                type="date"
              />
            </Col>
            <Col md="6" className="my-2">
              <label htmlFor="" className="form-label m-0">
                Drop Off Time
              </label>
              <CommonInput
                register={register}
                errors={errors}
                type="time"
                name={"dropOffTime"}
              />
            </Col>
            <Col md="12" className="my-2">
              <label htmlFor="" className="form-label m-0">
                Drop Off Land Mark
              </label>
              <CommonInput
                register={register}
                errors={errors}
                name={"dropOffLandmark"}
              />
            </Col>
          </>}

          <Col md="12" className="my-2">
            <label htmlFor="" className="form-label m-0">
              Contact Name
            </label>
            <CommonInput
              errors={errors}
              name={"dropOffContactName"}
              register={register}
            />
          </Col>
          <Col md="12" className="my-2">
            <label htmlFor="" className="form-label m-0">
              Contact Number
            </label>
            <PhoneInput
              value={watch("dropOffContactNumber")}
              onChange={(data, { dialCode }) => {
                setValue("dropOffContactNumber", data, {
                  shouldValidate: true,
                });
                setValue("dropOffCountryCode", dialCode);
              }}
              country={"us"}
            />

            {
              <p className="errorColor">
                {errors?.dropOffContactNumber &&
                  errors?.dropOffContactNumber?.message}
              </p>
            }
          </Col>
          {/* <Col md="12" className="my-2">
            <label htmlFor="" className="form-label m-0">
              Enter Bid Amount
            </label>
            <CommonInput
              errors={errors}
              name={"estimatedAmount"}
              register={register}
              disabled={true}
            />
          </Col>
          <Col md="12" className="my-2">
            <label htmlFor="" className="form-label m-0">
              Enter Images (max 5)
            </label>

            <div className="d-flex flex-wrap gap-10">
              {images?.map((item) => {
                return (
                  <div className="rounded">
                    <div
                      style={{
                        cursor: "pointer",
                        backgroundColor: "#c11111",
                      }}
                      className="text-white d-flex justify-content-end   "
                    >
                      <div
                        style={{
                          cursor: "pointer",
                          backgroundColor: "black",
                          height: 25,
                          width: 25,
                        }}
                        onClick={() => removeImageHandler(item)}
                        className="text-white text-center  rounded"
                      >
                        X
                      </div>
                    </div>
                    <img
                      src={item}
                      style={{
                        width: 100,
                        height: 100,
                      }}
                    />
                  </div>
                );
              })}
            </div>

            <div
              className="uploadfile position-relative p-3 rounded bg-light text-center"
              style={{ border: "1px dashed #ddd" }}
            >
              <input
                type="file"
                className="file position-absolute opacity-0 h-100 w-100 "
                style={{ left: 0, top: 0, zIndex: 9 }}
                accept="image/*"
                onChange={imageUploadHandler}
              // disabled={imageUploadLoader}
              />
              <div className="btn text-white d-inline-flex align-items-center justify-content-center commonBtn">
                {imageUploadLoader ? "Uploading..." : "Browse"}
              </div>
            </div>
          </Col> */}
          <Col lg="12" className="my-2">
            <Button
              type="submit"
              disable={loader || imageUploadLoader}
              className="btn d-flex align-items-center justify-content-center commonBtn w-100"
            >
              Next
            </Button>
          </Col>
        </Row>
      </Form>
    </>
  );
};

export default Step2;
